import Tabs from "@/store/api/data/Tabs";

export default {
    state: {
        tabs: [],
        selectedTab: {},
        isPaedActive: false,
        paedChangeSince: 0
    },
    getters: {},
    mutations: {
        setTabs(state, tabs) {
            state.tabs = tabs;
        },
        addTabs(state, tabs) {
            state.tabs.concat(tabs);
        },
        resetTabs(state) {
            state.tabs = [];
        },
        deleteTab(state, id) {
            state.tabs.splice(
                state.tabs.findIndex(tab => tab.id === id),
                1
            );
        },
        setSelectedTab(state, tab) {
            state.selectedTab = tab;
        },
        setIsPaedActive(state, value) {
            state.isPaedActive = value;
        },
        setPaedChangeSince(state, value) {
            state.paedChangeSince = value;
        }
    },
    actions: {
        getPharmacyTabs() {
            return Tabs.getPharmacyTabs().then(response => response.data);
        },
        addPharmacyTab({ commit }, tab) {
            return new Promise((resolve, reject) => {
                Tabs.addPharmacyTab(tab)
                    .then(newTab => {
                        commit("addTabs", newTab);
                        resolve(newTab);
                    }, commit)
                    .catch(error => reject(error));
            });
        },
        changeCustomPharmacyTab(context, tab) {
            return new Promise((resolve, reject) => {
                Tabs.changePharmacyTab(tab)
                    .then(resolve(tab))
                    .catch(error => reject(error));
            });
        },
        changeCustomPharmacyTabOrder(context, tabOrder) {
            return Tabs.changeCustomPharmacyTabOrder(tabOrder);
        },
        deleteCustomPharmacyTab({ commit }, tab) {
            return Tabs.deletePharmacyTab(tab).then(() => {
                commit("deleteTab", tab.id);
            });
        }
    }
};
